import dayjs from 'dayjs';

import { TaskGroups } from '../../entities/tasks';
import { monthList } from '../config';

export const getGroupedTaskName = (groupId: unknown, value: string): string => {
  if (value === TaskGroups.None) {
    return 'Все задачи';
  }

  const date = dayjs(value);

  if (groupId === TaskGroups.Month) {
    const mouth = date.format('MMMM');
    return mouth.charAt(0).toUpperCase() + mouth.slice(1);
  }

  if (groupId === TaskGroups.Day) {
    return date.format('D') + ' ' + monthList[date.month()];
  }

  if (groupId === TaskGroups.Year) {
    return date.format('YYYY');
  }

  return value;
};
